import React, { useState, useEffect } from 'react'
import {
  Form,
  Button,
  Modal,
  Col,
  Row,
  Card,
  Dropdown} from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import {
  BsFunnelFill,
  BsSearch,
  BsArrowClockwise,
  BsThreeDotsVertical,
  BsPencilFill,
  BsBookFill} from 'react-icons/bs'
import {
  LuGraduationCap} from 'react-icons/lu'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
import toast from 'react-hot-toast'
import EditClassModal from './EditClassModal'
import Cookies from 'js-cookie'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import { useLocation, useNavigate } from 'react-router-dom'
import { Typeahead } from 'react-bootstrap-typeahead'
import { useAuth } from './AuthContext'
import { useSidebar } from './SidebarContext'
import ProfileDropdown from './commonComponents/ProfileDropdown'
import TablePagination from './commonComponents/TablePagination'
import { useInstitute } from './commonComponents/InstituteContext'
import { FaChalkboard } from 'react-icons/fa'

const DataTable = () => {
  const { logout } = useAuth()
  const { isCollapsed } = useSidebar()
  const navigate = useNavigate()
  const [marginLeft, setMarginLeft] = useState('0px')
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
  )
  const [logoError, setLogoError] = useState(false)
  const { logo, name, id } = useInstitute();
  const [showFilterCard, setShowFilterCard] = useState(false)
  const [showEditModal, setShowEditModal] = useState(false)
  const [selectedClass, setSelectedClass] = useState(null)
  const [allClasses, setAllClasses] = useState([])
  const [selectedFilters, setSelectedFilters] = useState({
    class: ''})
  const [isAcknowledged, setIsAcknowledged] = useState(false)

  const [user, setUser] = useState(null)
  const [userRole, setUserRole] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        const expandedWidth = 245
        const collapsedWidth = 85
        const gap = 1

        setMarginLeft(
          isCollapsed
            ? `${collapsedWidth + gap}px`
            : `${expandedWidth + gap}px`,
        )
      } else {
        setMarginLeft('0px')
      }

      setIsMobile(window.innerWidth <= 768)
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [isCollapsed])

  useEffect(() => {
    const userLogged = Cookies.get('user')
    if (userLogged) {
      try {
        setUser(JSON.parse(userLogged))
        setUserRole(JSON.parse(userLogged))
      } catch (error) {
        console.error('Error parsing user data:', error)
        Cookies.remove('user')
      }
    }
  }, [])

  const initialData = []

  const [data, setData] = useState(initialData)
  const [search, setSearch] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(100)
  const [showModal, setShowModal] = useState(false)
  const [courses, setCourses] = useState([])

  useEffect(() => {
    ApiEndpoints.getAllCourses().then((res) => {
      setCourses(res.data.data)
      setAllCourses(res.data.data)
    })
  }, [])

  useEffect(() => {
    ApiEndpoints.getAllClasses()
      .then((response) => {
        console.log('Classes response: ', response.data.data)
        setData(response.data.data)
        setAllClasses(response.data.data)
      })
      .catch((error) => {
        toast.error('Failed to access data.')
      })
  }, [loading])

  const [allCourses, setAllCourses] = useState([])

  const handleCourseChange = (e) => {
    const courseId = e.target.value
    setSelectedFilters((prev) => ({ ...prev, course: courseId }))
    handleSelect({ course: courseId })
    console.log('HANDLESELECT:', handleSelect)
  }

  useEffect(() => {
    ApiEndpoints.getAllCourses()
      .then((response) => {
        console.log(response.data)
        // setData(response.data.data) // Current view (filtered/unfiltered)
        setAllCourses(response.data.data) // Full master list
        setCourses(response.data.data)
      })
      .catch((error) => {
        toast.error('Failed to access data.')
      })
  }, [loading])
  const [newClass, setNewClass] = useState({
    class_name: '',
    course_id: '',
    start_date: '',
    end_date: ''})

  // Filter Data Based on Search
  const filteredData = data.filter((item) =>
    Object.values(item).some((value) =>
      value !== null && value !== undefined
        ? value.toString().toLowerCase().includes(search.trim().toLowerCase())
        : false,
    ),
  )

  const [selectedData, setSelectedData] = useState({})

  const handleSelect = (selectedValues) => {
    setSelectedData(selectedValues)
    console.log('SETSELECTEDDATA:', selectedValues)
    fetchFilteredData(selectedValues)
  }

  const fetchFilteredData = (selectedValues) => {
    const { course } = selectedValues
    let updatedData = allClasses // <- this should be classes, not courses
    console.log('updatedData', updatedData)
    if (course) {
      updatedData = updatedData.filter(
        (item) => item.course_id?.toString() === course.toString(),
      )
    }

    setData(updatedData)
  }

  useEffect(() => {
    fetchFilteredData(selectedData)
  }, [])
  // Pagination Logic
  const totalPages = Math.ceil(filteredData.length / itemsPerPage)
  useEffect(() => {
    if (currentPage > totalPages && totalPages !== 0) {
      setCurrentPage(1)
    }
  }, [filteredData, totalPages])

  const indexOfLastItem = currentPage * itemsPerPage
  const indexOfFirstItem = indexOfLastItem - itemsPerPage
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem)

  // Handle Form Input
  const handleInputChange = (e) => {
    const { name, value } = e.target
    console.log(
      `Input Changed - Name: ${name}, Value: ${value} (Type: ${typeof value})`,
    )
    setNewClass((prev) => ({ ...prev, [name]: value }))
  }

  const handleSave = async (e) => {
    e.preventDefault()
    try {
      setLoading(true)
      const instituteId = Cookies.get('institute_id')
      console.log('INSITTUTE ID:', instituteId)
      console.log('Sending data: ', newClass)
      const payload = {
        ...newClass,
        'institute-Id': Number(instituteId)}
      console.log('PAYLOAD:', payload)
      const response = await ApiEndpoints.addClass(payload, id)
      setNewClass('Response: ', response)
      // setData(response.data.data)
      // Reset the form after submission
      setNewClass({
        class_name: '',
        course_id: '',
        start_date: '',
        end_date: ''})

      setShowModal(false)
      toast.success(response.data.result)
    } catch (error) {
      toast.error(error.response?.data?.result)
      setShowModal(false)
    } finally {
      setLoading(false)
    }
  }

  const handleRefresh = async () => {
    try {
      const response = await ApiEndpoints.getAllClasses()
      const allClassData = response.data.data
      setData(allClassData)
      setAllClasses(allClassData) // Optional but ensures allClasses stays in sync

      setSelectedData({})
      setSelectedFilters({ class: '', course: '' })
      setSearch('')
      setCurrentPage(1)
      console.success('Data refreshed successfully')
    } catch (error) {
      console.error('Failed to refresh data.')
    }
  }

  const location = useLocation()
  const handleBackToAddStudent = () => {
    navigate('/students', {
      state: {
        newStudent: location.state?.newStudent || {},
        studentImage: location.state?.studentImage || null,
        selectedNewCourse: location.state?.selectedNewCourse || null}})
  }

  return (
    <>
      <style>
        {`
          .dropdown-toggle-no-caret::after {
            display: none !important;
          }
          
          /* Fix Typeahead dropdown visibility - ensure it appears above filter card */
          .rbt-menu {
            z-index: 1051 !important;
            max-height: 300px !important;
            overflow-y: auto !important;
            position: absolute !important;
            width: 100% !important;
            background-color: #ffffff !important;
            border: 1px solid #D1D3D4 !important;
            border-radius: 8px !important;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06) !important;
            margin-top: 4px !important;
          }
          
          .rbt-input-wrapper {
            position: relative !important;
            z-index: 1 !important;
          }
          
          .rbt-input-main {
            border-radius: 8px !important;
            border: 1px solid #D1D3D4 !important;
            font-size: 14px !important;
            padding: 8px 12px !important;
            transition: all 0.2s ease !important;
            font-family: 'Inter', system-ui, sans-serif !important;
          }
          
          .rbt-input-main:focus {
            border-color: #223843 !important;
            outline: none !important;
            box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1) !important;
          }
          
          .rbt-menu .dropdown-item {
            padding: 10px 12px !important;
            font-size: 14px !important;
            font-family: 'Inter', system-ui, sans-serif !important;
            color: #111827 !important;
            cursor: pointer !important;
          }
          
          .rbt-menu .dropdown-item:hover,
          .rbt-menu .dropdown-item.active {
            background-color: #F3F4F6 !important;
            color: #111827 !important;
          }
          
          /* Ensure filter card container allows dropdown to overflow */
          .filter-card-container {
            overflow: visible !important;
            position: relative !important;
            z-index: 10 !important;
          }
        `}
      </style>
      <div 
        style={{ 
          marginLeft,
          transition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          willChange: 'margin-left',
          WebkitTransition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          position: 'relative',
          zIndex: 1,
          marginTop: '0px',
          marginRight: '0px',
          marginBottom: '0px',
          paddingLeft: isCollapsed ? '12px' : '12px',
          paddingRight: isCollapsed ? '12px' : '12px'}}
      >
        {/* Header */}
        <div
          className="container-fluid p-0"
          style={{
            marginTop: window.innerWidth < 992 ? '55px' : '-12px',
            paddingLeft: '0px',
            paddingRight: '0px'}}
        >
        <div style={{ marginLeft: isMobile ? '-13px' : '-40px' }}>
          <div 
            className="d-flex justify-content-between align-items-center"
            style={{
              background: '#F3F4F6',
              paddingLeft: '28px',
              paddingRight: '28px',
              paddingTop: '12px',
              paddingBottom: '12px',
              overflow: 'visible',
              borderBottom: '1px solid #D1D3D4',
              width: '100%'}}
          >
            {/* Left: Title and Add Class Button */}
            <div className="d-flex align-items-center gap-3">
              {/* School Logo */}
              <div style={{ 
                width: '40px', 
                height: '40px', 
                borderRadius: '50%', 
                overflow: 'hidden', 
                background: '#223843',
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center', 
                flexShrink: 0}}>
                {!logoError ? (
                  <img 
                    src={logo} 
                    alt="School Logo" 
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    onError={() => setLogoError(true)}
                  />
                ) : (
                  <LuGraduationCap size={20} style={{ color: '#ffffff' }} />
                )}
              </div>
              
              <h3 
                className="m-0 fw-bold" 
                style={{ 
                  letterSpacing: '-0.02em',
                  overflow: 'visible',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  fontSize: 'clamp(18px, 2.5vw, 22px)',
                  color: '#223843',
                  lineHeight: '1.2',
                  fontFamily: 'Inter, system-ui, sans-serif'}}
              >
                Manage Classes
              </h3>
              {/* {(user?.user_type === 'admin' || userRole?.roles?.includes("admin")) && (
                <button
                  onClick={() => setShowModal(true)}
                  style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    backgroundColor: '#223843',
                    border: 'none',
                    color: '#ffffff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    flexShrink: 0}}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#223843'
                    e.currentTarget.style.transform = 'scale(1.05)'
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#223843'
                    e.currentTarget.style.transform = 'scale(1)'
                  }}
                  title="Add New Class"
                >
                  <FaChalkboard size={20} />
                </button>
              )} */}
            </div>
            
            {/* Right: Profile Icon with Dropdown */}
            {!isMobile && (
              <ProfileDropdown logout={logout} />
            )}
          </div>
        </div>
        </div>
        <div
          className="container-fluid p-0 mt-4"
          style={{
            minHeight: '100vh',
            paddingLeft: isCollapsed ? '32px' : '40px',
            paddingRight: '32px',
            paddingTop: '32px',
            paddingBottom: '32px'}}
        >
          {/* Filter Toggle Button and Items Per Page */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div className="d-flex align-items-center gap-3">
              {/* Items Per Page Selector */}
              <div 
                className="d-flex align-items-center"
                style={{
                  backgroundColor: '#ffffff',
                  padding: '8px 16px',
                  borderRadius: '8px',
                  gap: '8px',
                  border: '1px solid #D1D3D4'}}
              >
                <span style={{ color: '#6b7280', fontSize: '13px', whiteSpace: 'nowrap', fontFamily: 'Inter, system-ui, sans-serif' }}>
                  Show:
                </span>
                <Form.Select
                  className="w-auto"
                  value={itemsPerPage}
                  onChange={(e) => {
                    setItemsPerPage(parseInt(e.target.value))
                    setCurrentPage(1)
                  }}
                  style={{
                    borderRadius: '6px',
                    border: '1px solid #D1D3D4',
                    backgroundColor: '#ffffff',
                    color: '#111827',
                    fontSize: '13px',
                    fontWeight: '500',
                    padding: '4px 32px 4px 12px',
                    minWidth: '140px',
                    transition: 'all 0.2s ease',
                    cursor: 'pointer',
                    height: '36px',
                    fontFamily: 'Inter, system-ui, sans-serif'}}
                  onFocus={(e) => {
                    e.target.style.borderColor = '#223843'
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = '#D1D3D4'
                  }}
                >
                  <option value="100">100 per page</option>
                  <option value="200">200 per page</option>
                  <option value="300">300 per page</option>
                </Form.Select>
              </div>
              <button
                onClick={() => setShowFilterCard(!showFilterCard)}
                style={{
                  width: '48px',
                  height: '48px',
                  borderRadius: '50%',
                  backgroundColor: showFilterCard ? '#223843' : '#ffffff',
                  border: '1px solid #D1D3D4',
                  color: showFilterCard ? '#ffffff' : '#223843',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease'}}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = showFilterCard ? '#223843' : '#223843'
                  e.currentTarget.style.color = '#ffffff'
                  e.currentTarget.style.borderColor = showFilterCard ? '#223843' : '#223843'
                  e.currentTarget.style.transform = 'scale(1.05)'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = showFilterCard ? '#223843' : '#ffffff'
                  e.currentTarget.style.color = showFilterCard ? '#ffffff' : '#223843'
                  e.currentTarget.style.borderColor = '#D1D3D4'
                  e.currentTarget.style.transform = 'scale(1)'
                }}
                title={showFilterCard ? 'Hide Filters' : 'Show Filters'}
              >
                <BsFunnelFill size={20} />
              </button>
            </div>
            {(user?.user_type === 'admin' || userRole?.roles?.includes("admin")) && (
              <button
                type="button"
                className="d-none d-md-flex align-items-center justify-content-center"
                onClick={() => setShowModal(true)}
                style={{
                  borderRadius: '10px',
                  padding: '6px 10px',
                  height: '44px',
                  border: 'none',
                  backgroundColor: '#223843',
                  color: '#ffffff',
                  gap: '6px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  whiteSpace: 'nowrap'}}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#1f323a'
                  e.currentTarget.style.transform = 'scale(1.03)'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#223843'
                  e.currentTarget.style.transform = 'scale(1)'
                }}
                title="Add New Class"
              >
                <FaChalkboard size={18} />
                <span style={{ fontSize: '12px', fontWeight: '650', fontFamily: 'Inter, system-ui, sans-serif' }}>
                  Add New Class
                </span>
              </button>
            )}
          </div>

          {(user?.user_type === 'admin' || userRole?.roles?.includes("admin")) && (
            <div className="d-md-none d-flex justify-content-end mb-4">
              <button
                type="button"
                onClick={() => setShowModal(true)}
                style={{
                  borderRadius: '10px',
                  padding: '6px 10px',
                  height: '44px',
                  border: 'none',
                  backgroundColor: '#223843',
                  color: '#ffffff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '6px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  whiteSpace: 'nowrap'}}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#1f323a'
                  e.currentTarget.style.transform = 'scale(1.03)'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#223843'
                  e.currentTarget.style.transform = 'scale(1)'
                }}
                title="Add New Class"
              >
                <FaChalkboard size={18} />
                <span style={{ fontSize: '12px', fontWeight: '650', fontFamily: 'Inter, system-ui, sans-serif' }}>
                  Add New Class
                </span>
              </button>
            </div>
          )}

          {/* Modern Filter Section */}
          <div 
            className="filter-card-container"
            style={{
              maxHeight: showFilterCard ? '1000px' : '0',
              overflow: showFilterCard ? 'visible' : 'hidden',
              transition: 'max-height 0.3s ease-in-out',
              marginBottom: showFilterCard ? '24px' : '0',
              position: 'relative',
              zIndex: showFilterCard ? 10 : 1}}
          >
            {showFilterCard && (
              <Card 
                style={{
                  border: '1px solid #D1D3D4',
                  borderRadius: '12px',
                  backgroundColor: '#ffffff',
                  overflow: 'visible',
                  position: 'relative'}}
              >
                {/* Header */}
                <div 
                  style={{
                    background: '#ffffff',
                    padding: '20px',
                    borderBottom: '1px solid #F3F4F6'}}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center gap-3">
                      <div 
                        style={{
                          width: '40px',
                          height: '40px',
                          borderRadius: '50%',
                          backgroundColor: '#223843',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'}}
                      >
                        <BsSearch style={{ color: '#ffffff', fontSize: '18px' }} />
                      </div>
                      <div>
                        <h5 className="m-0 fw-semibold text-start" style={{ color: '#111827', fontSize: '16px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                          Search & Filter Classes
                        </h5>
                        <p className="m-0 mt-1" style={{fontSize: '13px', color: '#6b7280' }}>
                          Find classes quickly with advanced filters
                        </p>
                      </div>
                    </div>
                    <div className="d-flex gap-2">
                      <button
                        onClick={handleRefresh}
                        style={{
                          width: '48px',
                          height: '48px',
                          borderRadius: '50%',
                          backgroundColor: '#223843',
                          border: 'none',
                          color: '#ffffff',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          cursor: 'pointer',
                          transition: 'all 0.2s ease'}}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = '#223843'
                          e.currentTarget.style.transform = 'scale(1.05)'
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = '#223843'
                          e.currentTarget.style.transform = 'scale(1)'
                        }}
                        title="Refresh"
                      >
                        <BsArrowClockwise size={20} />
                      </button>
                    </div>
                  </div>
                </div>

                <Card.Body className="p-4" style={{ backgroundColor: '#ffffff', overflow: 'visible', position: 'relative' }}>
                  <Row className="g-4 text-start">
                    {/* Filter by Course */}
                    <Col xs={12} md={6}>
                      <div style={{ 
                        padding: '20px', 
                        backgroundColor: '#F3F4F6', 
                        borderRadius: '8px',
                        border: '1px solid #D1D3D4',
                        overflow: 'visible',
                        position: 'relative'}}>
                        <div className="d-flex align-items-center gap-2 mb-3">
                          <div 
                            style={{
                              width: '32px',
                              height: '32px',
                              borderRadius: '50%',
                              backgroundColor: '#10B981',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center'}}
                          >
                            <BsSearch style={{ color: '#ffffff', fontSize: '16px' }} />
                          </div>
                          <label className="fw-semibold mb-0" style={{ color: '#111827', fontSize: '14px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                            Filter by Course
                          </label>
                        </div>
                        <div style={{ position: 'relative', zIndex: 1050 }}>
                          <label className="fw-semibold mb-2 d-block" style={{ color: '#6b7280', fontSize: '13px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                            Select Course
                          </label>
                          <div style={{ position: 'relative', zIndex: 1050 }}>
                            <Typeahead
                              id="course-select"
                              labelKey="name"
                              onChange={(selected) => {
                                const course = selected[0]
                                if (course) {
                                  handleCourseChange({ target: { value: course.id } })
                                } else {
                                  handleCourseChange({ target: { value: '' } })
                                }
                              }}
                              options={courses}
                              placeholder="Select Course"
                              selected={selectedFilters.course ? courses.filter(
                                (cs) => cs.id === Number(selectedFilters.course),
                              ) : []}
                            />
                          </div>
                        </div>
                      </div>
                    </Col>
                    {/* Search Class Name */}
                    <Col xs={12} md={6}>
                      <div style={{ 
                        padding: '20px', 
                        backgroundColor: '#F3F4F6', 
                        borderRadius: '8px',
                        border: '1px solid #D1D3D4'}}>
                        <div className="d-flex align-items-center gap-2 mb-3">
                          <div 
                            style={{
                              width: '32px',
                              height: '32px',
                              borderRadius: '50%',
                              backgroundColor: '#10B981',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center'}}
                          >
                            <BsSearch style={{ color: '#ffffff', fontSize: '16px' }} />
                          </div>
                          <label className="fw-semibold mb-0" style={{ color: '#111827', fontSize: '14px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                            Search Class Name
                          </label>
                        </div>
                        <div style={{ position: 'relative' }}>
                          <label className="fw-semibold mb-2 d-block" style={{ color: '#6b7280', fontSize: '13px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                            Enter Class Name
                          </label>
                          <div style={{ position: 'relative' }}>
                            <BsSearch 
                              style={{ 
                                position: 'absolute', 
                                left: '12px', 
                                top: '50%', 
                                transform: 'translateY(-50%)',
                                color: '#6b7280',
                                fontSize: '16px',
                                zIndex: 1}} 
                            />
                            <Form.Control
                              type="text"
                              placeholder="Search Class Name"
                              value={search}
                              onChange={(e) => setSearch(e.target.value)}
                              style={{
                                paddingLeft: '40px',
                                borderRadius: '8px',
                                border: '1px solid #D1D3D4',
                                fontSize: '14px',
                                height: '40px',
                                transition: 'all 0.2s ease',
                                backgroundColor: '#ffffff',
                                fontFamily: 'Inter, system-ui, sans-serif'}}
                              onFocus={(e) => {
                                e.target.style.borderColor = '#223843'
                              }}
                              onBlur={(e) => {
                                e.target.style.borderColor = '#D1D3D4'
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            )}
          </div>

        {/* Table */}
        <Card style={{ border: '1px solid #D1D3D4', borderRadius: '12px', overflow: 'hidden', backgroundColor: '#ffffff' }}>
          <Table className="table mb-0" style={{ borderRadius: '12px', overflow: 'hidden' }}>
            <Thead>
              <Tr style={{ backgroundColor: '#F3F4F6' }}>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Class Name</Th>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Course Name</Th>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Start Date</Th>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>End Date</Th>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Number of Students</Th>
                {(user?.user_type === 'admin' || userRole?.roles?.includes("admin")) && (
                  <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Action</Th>
                )}
              </Tr>
            </Thead>
            <Tbody>
              {currentItems.length > 0 ? (
                currentItems.map((item, index) => (
                  <Tr 
                    key={index}
                    style={{ 
                      backgroundColor: index % 2 === 0 ? '#ffffff' : '#F3F4F6',
                      transition: 'background-color 0.2s ease',
                      borderBottom: '1px solid #D1D3D4'}}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = '#F3F4F6'
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#ffffff' : '#F3F4F6'
                    }}
                  >
                    <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>{item.class_name}</Td>
                    <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>
                      {courses.find((course) => course.id === item.course_id)
                        ?.name || 'N/A'}
                    </Td>
                    <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>
                      {item?.start_date
                        ? new Date(item.start_date).toLocaleDateString('en-GB', {
                            day: '2-digit',
                            month: 'long',
                            year: 'numeric'})
                        : 'N/A'}
                    </Td>
                    <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>
                      {item?.end_date
                        ? new Date(item.end_date).toLocaleDateString('en-GB', {
                            day: '2-digit',
                            month: 'long',
                            year: 'numeric'})
                        : 'N/A'}
                    </Td>
                    <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>{item.student_count || 0}</Td>
                    {(user?.user_type === 'admin' || userRole?.roles?.includes("admin")) && (
                      <Td className="text-center" style={{ padding: '16px', border: 'none' }}>
                        {/* Desktop View - Dropdown */}
                        <div className="d-none d-md-block">
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="light"
                              id={`dropdown-${item.id}`}
                              style={{
                                width: '36px',
                                height: '36px',
                                borderRadius: '50%',
                                backgroundColor: 'transparent',
                                border: '1px solid #D1D3D4',
                                padding: '0',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                transition: 'all 0.2s ease'}}
                              className="dropdown-toggle-no-caret"
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = '#223843'
                                e.currentTarget.style.borderColor = '#223843'
                                e.currentTarget.style.color = '#ffffff'
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = 'transparent'
                                e.currentTarget.style.borderColor = '#D1D3D4'
                                e.currentTarget.style.color = '#111827'
                              }}
                            >
                              <BsThreeDotsVertical style={{ color: 'inherit' }} />
                            </Dropdown.Toggle>

                            <Dropdown.Menu
                              style={{
                                borderRadius: '8px',
                                border: '1px solid #D1D3D4',
                                padding: '8px',
                                minWidth: '180px'}}
                            >
                              <Dropdown.Item
                                onClick={() => {
                                  setSelectedClass(item)
                                  setShowEditModal(true)
                                }}
                                style={{
                                  fontSize: '13px',
                                  padding: '10px 12px',
                                  color: '#111827',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '10px',
                                  transition: 'all 0.2s ease',
                                  borderRadius: '6px',
                                  fontFamily: 'Inter, system-ui, sans-serif'}}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor = '#10B981'
                                  e.currentTarget.style.color = '#ffffff'
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor = 'transparent'
                                  e.currentTarget.style.color = '#111827'
                                }}
                              >
                                <BsPencilFill size={18} /> Edit Class
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>

                        {/* Mobile View - Circular Button in Single Line */}
                        <div className="d-md-none d-flex" style={{justifyContent: isMobile ? 'flex-start' : 'center'}}>
                          <button
                            onClick={() => {
                              setSelectedClass(item)
                              setShowEditModal(true)
                            }}
                            style={{
                              width: '36px',
                              height: '36px',
                              borderRadius: '50%',
                              backgroundColor: '#10B981',
                              border: 'none',
                              color: '#ffffff',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              transition: 'all 0.2s ease',
                              cursor: 'pointer'}}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = '#059669'
                              e.currentTarget.style.transform = 'scale(1.1)'
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = '#10B981'
                              e.currentTarget.style.transform = 'scale(1)'
                            }}
                            title="Edit Class"
                          >
                            <BsPencilFill size={16} />
                          </button>
                        </div>
                      </Td>
                    )}
                  </Tr>
                ))
              ) : (
                <Tr>
                  <Td colSpan={(user?.user_type === 'admin' || userRole?.roles?.includes("admin")) ? "6" : "5"} className="text-center" style={{ padding: '40px', fontSize: '14px', color: '#6b7280', fontFamily: 'Inter, system-ui, sans-serif' }}>
                    No records found
                  </Td>
                </Tr>
              )}
            </Tbody>
          </Table>
        </Card>


        {/* Pagination & Total Records */}


                <TablePagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalPages={totalPages}
          indexOfFirstItem={indexOfFirstItem}
          indexOfLastItem={indexOfLastItem}
          totalItems={filteredData.length}
          itemLabel="classes"
        />
        </div>

      {/* Add New Class Modal */}
      <Modal
        size="lg"
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
      >
        <Modal.Header closeButton 
        closeVariant="white"
        className="text-white" style={{backgroundColor: '#223843'}}>
          <Modal.Title>Add New Class</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSave}>
            <Form.Group className="mb-3">
              <Form.Label>Course *</Form.Label>
              <Form.Select
                name="course_id"
                value={newClass.course_id}
                onChange={handleInputChange}
                required
              >
                <option value="">Select Course</option>
                {courses.map((course) => (
                  <option key={course.id} value={course.id}>
                    {course.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            {/* Class Name Field */}
            <Form.Group className="mb-3">
              <Form.Label className="">Class Name *</Form.Label>
              <Form.Control
                type="text"
                name="class_name"
                value={newClass.class_name}
                onChange={handleInputChange}
                placeholder="Enter Class Name"
                className="p-2 border rounded"
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label className="">Start Date</Form.Label>
              <Form.Control
                type="date"
                name="start_date"
                value={newClass.start_date}
                onChange={handleInputChange}
                className="p-2 border rounded"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label className="">End Date</Form.Label>
              <Form.Control
                type="date"
                name="end_date"
                value={newClass.end_date}
                onChange={handleInputChange}
                className="p-2 border rounded"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Check
                className="text-danger"
                type="checkbox"
                id="acknowledgeCheckbox"
                label="I acknowledge and agree that this process is irreversible and cannot be undone."
                checked={isAcknowledged}
                onChange={(e) => setIsAcknowledged(e.target.checked)}
              />
            </Form.Group>
            <Modal.Footer>
              <Button variant="danger" onClick={() => setShowModal(false)}>
                Cancel
              </Button>
              <Button
                variant="success"
                type="submit"
                disabled={!isAcknowledged}
              >
                Save Class
              </Button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal>
      <EditClassModal
        show={showEditModal}
        handleClose={() => setShowEditModal(false)}
        classData={selectedClass}
      />
      </div>
    </>
  )
}

export default DataTable

